import { createSlice } from '@reduxjs/toolkit';

/* ----------------------------------------------------------------
      SLICE (ACTIONS/REDUCERS)
---------------------------------------------------------------- */

const initialState = {
  endYear: 2050,
};

const endYearSlice = createSlice({
  name: 'endYear',
  initialState,
  reducers: {
    updateEndYear(state, action) {
      state.endYear = action.payload;
    },
  },
});

export const { updateEndYear } = endYearSlice.actions;
export default endYearSlice.reducer;
